import { z } from 'zod';

const DATE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

/** Header of a sales or purchase return (the reason is optional there). */
export const returnHeaderSchema = z.object({
  docDate: z.string().regex(DATE, 'Pick a date'),
  reason: z.string().trim().max(500, 'Keep it under 500 characters'),
  notes: z.string().trim().max(2000, 'Keep it under 2000 characters'),
});
export type ReturnHeaderValues = z.infer<typeof returnHeaderSchema>;

/** Header of a credit or debit note without returned goods: a reason is required. */
export const noteHeaderSchema = returnHeaderSchema.extend({
  reason: z
    .string()
    .trim()
    .min(3, 'Say why (at least 3 characters)')
    .max(500, 'Keep it under 500 characters'),
});
export type NoteHeaderValues = z.infer<typeof noteHeaderSchema>;
